import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAcademicTitle } from '../../Interfaces/IAcademicTitle';
import { IRelationshipType } from '../../Interfaces/IRelationshipType';

const initialState = { storeRelationshipType: [] as IRelationshipType[] };

const sliceRelationshipType = createSlice({
  name: 'RELATIONSHIPTYPE',
  initialState,
  reducers: {
    setRelationshipTypeArray: (state, action: PayloadAction<IRelationshipType[]>) => {
      state.storeRelationshipType = [...action.payload];
    },
    addUpdateRelationshipTypeArray: (
      state,
      action: PayloadAction<IRelationshipType>
    ) => {
      const testObject = state.storeRelationshipType.find(
        x => x.idRelationshipType === action.payload.idRelationshipType
      );

      if (testObject) {
        state.storeRelationshipType = [
          ...state.storeRelationshipType.map(x =>
            x.idRelationshipType === action.payload.idRelationshipType
              ? action.payload
              : x
          ),
        ];
      } else {
        state.storeRelationshipType = [
          action.payload,
          ...state.storeRelationshipType,
        ];
      }
    },
  },
});
export const { setRelationshipTypeArray, addUpdateRelationshipTypeArray } =
sliceRelationshipType.actions;
export default sliceRelationshipType.reducer;
